export enum CustomEventTypes {
    PlayerDeath = "PlayerDeath"
}